/*
 * hyperion-index:begin
 * ---
 * path: hyperion-cloud/web/src/capabilities/device-management/components/SiteAssessmentNotificationHandler.tsx
 * layer: web
 * area: components
 * kind: component
 * web_root: components
 * relpath: web/src/capabilities/device-management/components/SiteAssessmentNotificationHandler.tsx
 * filename: SiteAssessmentNotificationHandler.tsx
 * extension: tsx
 * ---
 * hyperion-index:end
 */

import { useEventSource } from '@/platform/realtime/hooks/useEventSource';
import { toast } from 'sonner';

/**
 * SiteAssessmentNotificationHandler listens for Site Assessment scan events and displays notifications.
 * Integrates with Sonner for toast notifications.
 */
export function SiteAssessmentNotificationHandler() {
  useEventSource({
    eventTypes: ['customer-lifecycle.opportunity.created_from_scan'],
    onEvent: (event) => {
      if (event.type === 'customer-lifecycle.opportunity.created_from_scan') {
        const data = event.data as { customer_name?: string } | undefined;
        const customerName = data?.customer_name || 'Unknown';

        toast.success('Site Assessment scan complete', {
          description: `Customer Lifecycle opportunity created for ${customerName}`,
          duration: 8000,
        });
      }
    },
    autoConnect: true,
  });

  return null; // This is a non-visual handler
}
